var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{directives:[{name:"authenticated-image",rawName:"v-authenticated-image",value:(_vm.getLastReviewImageFile(_vm.customerDetails)),expression:"getLastReviewImageFile(customerDetails)"}],staticClass:"image-preview"})])
}
var staticRenderFns = []

export { render, staticRenderFns }